import { useState } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import WhyChooseUs from './components/WhyChooseUs';
import Gallery from './components/Gallery';
import CallToAction from './components/CallToAction';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function HomePage() {
  const [navBackground, setNavBackground] = useState(false);

  const handleScroll = () => {
    if (window.scrollY > 100) {
      setNavBackground(true);
    } else {
      setNavBackground(false);
    }
  };

  useState(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  });

  return (
    <div className="min-h-screen">
      <Hero navBackground={navBackground} />
      <About />
      <Services />
      <WhyChooseUs />
      <Gallery />
      <CallToAction />
      <Contact />
      <Footer />
    </div>
  );
}